import React from "react";
import styled from "styled-components";
import { MSG_ERROR, MSG_SUCCESS } from "constants/styles";

import { ReactComponent as ErrorIcon } from "../../../assets/img/icons/error.svg";
import { ReactComponent as SuccessIcon } from "../../../assets/img/icons/success.svg";
import { ReactComponent as SpeakerIcon } from "../../../assets/img/icons/Speaker.svg";
import Outlook from "../../../assets/img/PublishMenu/Outlook.png";
import GlobalStyle from "./../../../GlobalStyle";
import { openOverlay } from "modules/GlobalActions";

const Message = (props) => {
  let icon;
  if (props.type === "error") {
    icon = <ErrorIcon />;
  } else if (props.type === "info") {
    if (props?.outlookSuccess) icon = <img style={{ marginRight: 10 }} src={Outlook} alt="Email with Outlook" />;
    else icon = <SpeakerIcon />;
  } else {
    icon = <SuccessIcon />;
  }
  const { iconClass, setEmailWithOutlookConfirmation } = props;

  const messageClickHandler = () => {
    setEmailWithOutlookConfirmation && setEmailWithOutlookConfirmation(true);
  };

  return (
    <>
      <GlobalStyle />
      <ErrorWrapper {...props}>
        <div className="d-flex align-items-start">
          <div
            className={`flex-shrink-1 ${iconClass ? iconClass : ""} ${props.outlookSuccess ? "outlook-icon" : ""}`}
          >
            {icon}
          </div>
          <div className="flex-grow-1">
            <p className={`message-title ${props.outlookSuccess ? "enlarge-font" : ""}`}>
              <span className={`${props.type}`}>{props.label}</span>
            </p>
            <p
              className={`message-description ${props.outlookSuccess ? "outlook-auth-success" : ""} ${
                props.setEmailWithOutlookConfirmation ? "cursor-style" : ""
              }`}
              onClick={props.outlookSuccess && setEmailWithOutlookConfirmation ? messageClickHandler : null}
            >
              {props.message}
            </p>
          </div>
          {props?.callToAction && props?.callToAction()}
        </div>
      </ErrorWrapper>
    </>
  );
};

export default Message;

const ErrorWrapper = styled.div`
  display: block;
  width: 100%;
  background: ${(props) => (props.type === "error" ? MSG_ERROR : MSG_SUCCESS)};
  padding: 20px 12px;
  border-radius: 8px;
  ${(props) => (props.marginBottom ? `margin-bottom: ${props.marginBottom}px;` : "")}
  ${(props) => (props.marginTop ? `margin-top: ${props.marginTop}px;` : "20px")}
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-top: 10px;
    padding: 10px 12px;
    border-radius: 6px;
  }
  svg {
    float: left;
    display: inline;
    width: auto;
    margin-right: 10px;
    margin-top: 5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 20px;
      margin-top: 1px;
    }
  }
  .message-title {
    font-size: 12px;
    color: #27ce0a;
    font-weight: 500;
    line-height: 16px;
    margin: 0;
    letter-spacing: -0.3px;
    font-family: "robotomedium";
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 9px;
      line-height: 12px;
    }
    span.success {
      color: #27ce0a !important;
    }
    span.error {
      color: #ffa112 !important;
    }
    &.enlarge-font {
      /* font-size: 16px; */
      font-family: "robotobold";
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 25px;
      letter-spacing: -0.388889px;
      color: #1ec252;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
    }
  }
  .message-description {
    color: #424b50;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    margin: 0;
    letter-spacing: -0.4px;
    font-family: "robotobold";
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
    }
    &.outlook-auth-success {
      text-decoration: underline;
      /* font-size: 14px; */
      font-weight: 700;
      font-size: 10px;
      line-height: 1;
      letter-spacing: -0.277778px;
      color: #424b50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
    }
    &.cursor-style {
      cursor: pointer;
    }
  }
  .search-terms-wrap .add-words-wrapper {
    display: none;
  }
  .outlook-icon {
    margin-bottom: 10px;
  }
`;
